import { render, staticRenderFns } from "./ImagenesData.vue?vue&type=template&id=f95d7b7a&"
import script from "./ImagenesData.vue?vue&type=script&lang=js&"
export * from "./ImagenesData.vue?vue&type=script&lang=js&"
import style0 from "./ImagenesData.vue?vue&type=style&index=0&id=f95d7b7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports